import React from 'react';

import { CounterField } from './CounterField';

export const RoundedCounterField = ({
  name,
  label,
  min,
  max,
  customError,
  required,
  width,
}: {
  name: string;
  label?: string;
  min: number;
  max?: number;
  customError?: boolean;
  required?: boolean;
  width?: string;
}) => {
  return (
    <CounterField
      name={name}
      label={label}
      min={min}
      max={max}
      border="1px solid transparent"
      disableFocusWithin
      flexDirection="row"
      width={width || '30%'}
      inputIconRounded
      fontSizeLabel="1rem"
      paddingLabel="0"
      customError={customError}
      required={required}
    />
  );
};
